import React from 'react';
import PropTypes from "prop-types";
import classNames from "classnames";

export default class Tab extends React.Component
{
    static propTypes = {
        active: PropTypes.bool,
        component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    };

    static defaultProps = {
        active: false,
        component: 'a',
    };

    render()
    {
        const {
            component: Component,
            children,
            className,
            active,
            ...other
        } = this.props;

        const classes = classNames(
            className,
            'whitespace-nowrap pb-4 pt-2 px-1 border-b-2 text-md leading-5 ',
            {
                "border-blue-500 text-blue-600 focus:outline-none focus:text-blue-800 focus:border-blue-700": active,
                "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-400 focus:outline-none focus:text-gray-700 focus:border-gray-300": ! active
            }
        );

        return <Component {...other} className={classes} aria-current="page">
            { children }
        </Component>;
    }
}
